import { parsePayloadForQuery } from '@/helpers/utils.js';
import axios from 'axios';
import Vue from 'vue';

export const MODAL_NAME = {
  CREATE: 'create',
  EDIT_DETAILS: 'editDetails',
  GRANT_PERMISSION: 'grantPermission'
}

const state = {
  items: [],
  modals: {
    create: false,
    editDetails: false,
    grantPermission: false
  },
  item: null
};

const getters = {
  getRole: state => state.item,
  getRoles: state => state.items,
  isCreateOpen: state => state.modals.create,
  isEditDetailsOpen: state => state.modals.editDetails,
  isGrantPermissionOpen: state => state.modals.grantPermission
};

const mutations = {
  itemsLoaded(state, payload) {
    state.items = payload;
  },
  itemLoaded(state, payload) {
    state.item = payload;
  },
  open(state, modalName) {
    Vue.set(state.modals, modalName, true);
  },
  close(state, modalName) {
    Vue.set(state.modals, modalName, false);
  },
};

const actions = {
  get(state, payload) {
    let queryParams = '?' + parsePayloadForQuery(payload);
    return axios.get(`/roles${queryParams}`);
  },
  getUsers(state, payload) {
    let queryParams = '?' + parsePayloadForQuery(payload);
    return axios.get(`/roles/users${queryParams}`);
  },
  getModules(state, payload) {
    let queryParams = '?' + parsePayloadForQuery(payload);
    return axios.get(`/roles/modules${queryParams}`);
  },
  getPermissions(state, payload) {
    let queryParams = '?' + parsePayloadForQuery(payload);
    return axios.get(`/roles/permissions${queryParams}`);
  },
  create(state, payload) {
    return axios.post(`/roles`, payload)
      .then(({ data }) => {
        if (!!data.failures && data.failures.length > 0) {
          console.error('Create role - ERROR - ', data.failures[0].error);
          throw data.failures[0];
        } else {
          return data.successes;
        }
      }).catch(err => { throw err });
  },
  edit(state, payload) {
    return axios.patch(`/roles`, payload)
      .then(({ data }) => {
        if (!!data.failures && data.failures.length > 0) {
          console.error('Edit role - ERROR - ', data.failures[0].error);
          throw data.failures[0];
        } else {
          return data.successes;
        }
      }).catch(err => { throw err });
  },
  updatePermission(state, payload) {
    return axios.post(`/roles/update-permissions`, payload)
      .then(({ data }) => {
        if (!!data.failures && data.failures.length > 0) {
          console.error('Edit Permission Assignment - ERROR - ', data.failures);
          throw data.failures;
        } else {
          return data.successes;
        }
      }).catch(err => { throw err });
  },
  delete(state, payload) {
    return axios.delete(`/roles?ids=${payload}`)
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};